// src/api/auth.network.ts
import { http } from './http.ts';
import { ENDPOINTS } from './endpoints.ts';

export const AuthNetwork = {
  validationEmail: (email: string) =>
    http.get(ENDPOINTS.validation.validationEmail(email)),

  validationUsername: (name: string) =>
    http.get(ENDPOINTS.validation.validationUsername(name)),

  signUp: (data: any) =>
    http.post(ENDPOINTS.auth.signUp, data),

  signIn: (params: { email: string; password: string; fcmToken?: string }) =>
    http.post(ENDPOINTS.auth.signIn, {
      email: params.email,
      password: params.password,
      fcm_token: params.fcmToken,
    }),

  updateUserInfo: (data: any) =>
    http.patch(ENDPOINTS.user.updateUserInfo, data),

  signOut: () =>
    http.post(ENDPOINTS.auth.signOut),

  withdrawalAccount: () =>
    http.delete(ENDPOINTS.auth.withdrawalAccount),
};